import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import session from 'containers/App/session';
import SelectInput from '../../UI/selectInput';
import ApaleoConnect from '../../../../../components/ApaleoConnect';

import './propertyHeader.style.css';
import { sortBy, uniqBy } from 'lodash';

const PropertyHeader = () => {
    const dispatch = useDispatch();
    const selectedPropertyId = useSelector(session.selectors.selectSelectedPropertyId);
    const properties = useSelector(session.selectors.selectAuthorisedPropertiesList);

    const handleSelect = ({ value }) => {
        dispatch(session.actions.selectProperty(value));
    };

    const renderPropertySelect = () => {
        if (!properties) return null;
        let props = properties.filter((obj) => obj.archived === 0);
        const groups = uniqBy(
            props.filter((p) => p.hotelGroupID),
            'hotelGroupID',
        );
        if (groups.length === 1) {
            props = sortBy(props, ['hotelGroupRanking']);
        }
        props = props.map((property) => ({
            value: property.id,
            text: property.name,
        }));

        return (
            <SelectInput
                id="properties"
                options={props}
                className="PropertyHeaderSelect"
                onChange={handleSelect}
                value={selectedPropertyId}
            />
        );
    };

    return (
        <div className="PropertyHeaderWrapper">
            <div className="PropertyHeader">
                <nav className="PropertyHeaderNav">
                    <ul className="PropertyHeaderMenu">
                        <li className="PropertyHeaderMenuItem">You are currently viewing</li>
                        <li className="PropertyHeaderMenuItem">{renderPropertySelect()}</li>
                        <li className="PropertyHeaderMenuItem">
                            <ApaleoConnect />
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    );
};

export default PropertyHeader;
